const
  NAME               = 'closeGallery',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME],

  GALLERY_COUNTER    = 'squido-carousel-galleries-opened'
;

class CloseGallery {
  constructor(element$) {
    element$.on('click', this.clicked.bind(this));
  }

  clicked() {
    var key = this.getSessionStorageCounter() + 1;
    window.history.go(-key);
    this.removeSessionStorageCounter();
  }

  getSessionStorageCounter() {
    var value = window.sessionStorage.getItem(GALLERY_COUNTER).split();
    return Number(value[0]);
  }

  removeSessionStorageCounter() {
    window.sessionStorage.removeItem(GALLERY_COUNTER);
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(/*config*/) {
    return this.each(function() {
      new CloseGallery($(this));
    });
  }
}

$.fn[NAME]             = CloseGallery._jQueryInterface;
$.fn[NAME].Constructor = CloseGallery;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return CloseGallery._jQueryInterface;
};

export default CloseGallery;



// WEBPACK FOOTER //
// ./src/plugins/close-gallery.js